



























import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
@Component({})
export default class AddMemberDialog extends Vue {
  @Prop()
  private projectId: any;
  @Prop()
  private role: any;
  @Prop()
  private cMember: any;
  @Prop()
  private visible: any;
  private hospitals: any[] = [];
  private member: any = {};
  private visibleChange() {
    this.$emit("update:visible", this.visible);
  }
  private get ifVisible() {
    return this.visible ? this.visible : false;
  }
  private set ifVisible(val) {
    this.$emit("update:visible", val);
  }
  /**
   * @description 获取该项目所属的所有分中心
   */
  private fetchHospitals() {
    const params: any = {
      params: {
        project_id: this.projectId
      }
    };
    axios.get("api/project/user/hospitals", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.hospitals = data.data;
        this.hospitals.unshift({ hospital_id: "", 医院名称: "全部医院" });
      });
    });
  }
  /**
   * @description 确定添加患者并进入采集页面
   */
  private addMember() {
    this.member.project_id = this.projectId;
    const params: any = this.member;
    params["角色"] = this.role.value;
    axios.post("api/project/user", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.$message.success("加入成功");
        this.$emit("finish", data.data);
      });
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchHospitals();
    if (this.cMember) {
      this.member = this.cMember;
    }
  }
}
